import { useSelector } from 'react-redux';

export default function useFlag(flag) {
  const flagId = flag.id ?? flag.ffsKey ?? flag;
  return useSelector((state) => {
    return state?.flags?.[flagId];
  });
}
